module.exports = __webpack_public_path__ + "media/04.7aef59f9.mp4";